(function($) {

	$(document).foundation();	

})( jQuery );  